import { useEffect } from "react";

export const SITE_URL = "https://colaboratoriocarpintero.com";
const DEFAULT_IMAGE = `${SITE_URL}/Logos%20CC%20web.png`;

function setMeta(attr, key, content) {
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  const prevContent = el ? el.getAttribute("content") : null;
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
  return prevContent;
}

function setCanonical(href) {
  let el = document.querySelector('link[rel="canonical"]');
  const prevHref = el ? el.getAttribute("href") : null;
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
  return prevHref;
}

// Actualiza título, meta description, canonical, Open Graph/Twitter y JSON-LD
// para la página actual, y restaura los valores por default (los de
// public/index.html) al desmontar — así la home no hereda el meta de otra ruta.
export default function Seo({ title, description, path = "/", image, jsonLd }) {
  useEffect(() => {
    const prevTitle = document.title;
    const url = `${SITE_URL}${path}`;
    const finalImage = image || DEFAULT_IMAGE;

    document.title = title;
    const prevDescription = setMeta("name", "description", description);
    const prevCanonical = setCanonical(url);
    const prevOgTitle = setMeta("property", "og:title", title);
    const prevOgDescription = setMeta("property", "og:description", description);
    const prevOgUrl = setMeta("property", "og:url", url);
    const prevOgImage = setMeta("property", "og:image", finalImage);
    const prevTwTitle = setMeta("name", "twitter:title", title);
    const prevTwDescription = setMeta("name", "twitter:description", description);
    const prevTwImage = setMeta("name", "twitter:image", finalImage);

    const jsonLdArray = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];
    const scripts = jsonLdArray.map((data) => {
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.textContent = JSON.stringify(data);
      document.head.appendChild(script);
      return script;
    });

    return () => {
      document.title = prevTitle;
      if (prevDescription !== null) setMeta("name", "description", prevDescription);
      if (prevCanonical !== null) setCanonical(prevCanonical);
      if (prevOgTitle !== null) setMeta("property", "og:title", prevOgTitle);
      if (prevOgDescription !== null) setMeta("property", "og:description", prevOgDescription);
      if (prevOgUrl !== null) setMeta("property", "og:url", prevOgUrl);
      if (prevOgImage !== null) setMeta("property", "og:image", prevOgImage);
      if (prevTwTitle !== null) setMeta("name", "twitter:title", prevTwTitle);
      if (prevTwDescription !== null) setMeta("name", "twitter:description", prevTwDescription);
      if (prevTwImage !== null) setMeta("name", "twitter:image", prevTwImage);
      scripts.forEach((s) => s.remove());
    };
  }, [title, description, path, image, jsonLd]);

  return null;
}
